import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getAsset = ({ id }) => {
  return axios.get(`/collaterals/${id}`);
};

export const useAsset = ({ id, config }) => {
  return useQuery({
    ...config,
    queryKey: ['asset', id],
    queryFn: () => getAsset({ id }),
  });
};
